import React, { useEffect, useRef, useState, useContext } from 'react'
import { observer } from 'mobx-react'
import WindowImage from './Window.image'
import styles from './Workspace.window.module.scss'
import WorkspaceWindowInfo from './Workspace.windowInfo'
import { iconsGallery } from '../../assets/icons'
import styled from 'styled-components'
import { genderParser } from '../../utils/genderParser'
import ReactLoading from "react-loading";
import { useAPI } from '../../hooks/useAPI'
import {formatDate} from "../../utils/formatDate";
import { AuthContext } from '../../context/AuthContext'


export const WorkspaceWindow = observer((props) => {
	
  const { zoom } = props.store
  const mode = props?.store?.workspace?.length
  const [windowSize, setWindowSize] = useState({ height: 0, width: 0 })
  const [refreshSize, setRefreshSize] = useState(true)
  const [image, setImage] = useState("")
  const [loading, setLoading] = useState(false)
  const { APIRequest } = useAPI()
  const {userId, token } = useContext(AuthContext)

  const windowRef = useRef({
    clientHeight: 0,
    clientWidth: 0
  })

  //const {request, loading} = useAPI()

  useEffect(() => {
    setTimeout(() => {
      setRefreshSize(!refreshSize)
    }, 1000)
  }, [props.store.viewerMode])

  useEffect(() => {
    setWindowSize({
      height: windowRef?.current?.clientHeight,
      width: windowRef?.current?.clientWidth
    })
  }, [props.imageSrc, props.store.workspace.length, refreshSize])

  const getImage = async (resultId) => {
	  console.log('getImage:',resultId)
	  try {
		setLoading(true) 
		APIRequest({api:`/api/v2/patients/${userId}/view/${resultId}`, method: 'GET'})
		.then((result) => { 
			setImage(`data:image/png;base64,${result.body}`)
			setLoading(false)
		})
		.catch((error) => { 
			console.log('error', error)
			setLoading(false)
		})
	  } catch (e) {
			console.log('err', e)
			setLoading(false)
	  }
	/*
    if (props.store.mode === 'testing') {
      await request(API_Testing.getImageById(props?.store?.attributes?.id, resultId))
          .then((result) => setImage(`data:image/png;base64,${result.body}`))
          .catch((error) => console.log('error', error))
    }

    if (props.store.mode === 'reading') {
      await request(API_Reading.getImage(resultId))
          .then((result) => setImage(`data:image/png;base64,${result.body}`))
          .catch((error) => console.log('error', error))
    }
	*/
  }
  useEffect( ()=> {
     getImage(props.id) // props.id
  },[props.id])

  return (
      <ViewerWindow
          ref={windowRef}
          border={props.isActual}
          id={props.id}
          mode={mode}
          onWheel={(event) =>
              !props.magnifier && zoom(props.id, event.deltaY < 0 ? 0.1 : -0.1)
          }
          onMouseDown={(_) => {
            props.store.selectWindow(props.id)
          }}
      >
        {!loading ?
            <WindowImage
                id={props.id}
                setZoom={props.store.setZoom}
                magnifier={props.magnifier}
                {...windowSize}
                styles={props.styles}
                imageSrc={image}
            />
            :
            <ReactLoading type={'spin'} width={170} height={170} color={'rgb(0, 159, 245)'} />}

        <WorkspaceWindowInfo
            className={styles.top}
            text={[genderParser(props.sex), formatDate(props.dob)]}
        />

        <WorkspaceWindowInfo className={styles.bottom} text={[formatDate(props.date)]} />

        {!props.isMain && (
            <>
              <RightArrow
                  onClick={() =>  props.store.switchWindow(props.id, 'next')}
              >
                <img src={iconsGallery.arrowRight}/>
              </RightArrow>
              <LeftArrow
                  onClick={(_) => props.store.switchWindow(props.id, 'prev')}
              >
				<img src={iconsGallery.arrowLeft}/>
              </LeftArrow>
            </>
        )}
      </ViewerWindow>
  )
})

var ViewerWindow = styled.div`
  position: relative;
  border: ${(p) => p.border && '5px solid rgba(127, 196, 253, 1)'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: unset;
  user-select: none;
  overflow: hidden;
  transition: 500ms;
  width: ${(p) => {
    switch (p.mode) {
      case 1:
        return '100%'
      case 2:
        return '50%'
      default:
        return '50%'
    }
  }};
  height: ${(p) => {
    switch (p.mode) {
      case 1:
        return '100%'
      case 2:
        return '100%'
      default:
        return '50%'
    }
  }};

  background: black;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}`

var RightArrow = styled.div`
  position: absolute;
  right: 15px;
  cursor: pointer;
  top: 50%;
`
var LeftArrow = styled.div`
  position: absolute;
  left: 15px;
  cursor: pointer;
  top: 50%;
`
